import React from "react";

function FooterRegistraion() {
  return (
    <>
      <hr />
      <p style={{ color: "#74767E" }}>© FoodFlow.co.2023.</p>
    </>
  );
}

export default FooterRegistraion;
